// extracted by mini-css-extract-plugin
module.exports = {"LinkContainer":"LinkSection_LinkContainer__1Rptf","Link":"LinkSection_Link__3XIoq","LinkText":"LinkSection_LinkText__1n5Dw"};